module.exports = __webpack_public_path__ + "img/tcd.a0923ddc.svg";